(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
function initIngredientFormula(context = document) {
  const roots = context.matches?.('[data-ingredients-editorial]') ? [context] : context.querySelectorAll('[data-ingredients-editorial]');
  roots.forEach((root) => {
    if (root.dataset.formulaReady) return;
    const dialog = root.querySelector('.ingredient-formula-dialog');
    const opener = root.querySelector('[data-open-ingredient-formula]');
    if (!dialog || !opener) return;
    root.dataset.formulaReady = 'true';
    opener.addEventListener('click', () => dialog.showModal());
    root.querySelector('[data-close-ingredient-formula]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { if (opener.isConnected) opener.focus({ preventScroll: true }); });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initIngredientFormula());
else initIngredientFormula();
document.addEventListener('shopify:section:load', (event) => initIngredientFormula(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
  (() => {
    const storageKey = 'neloura-welcome-popup-dismissed';

    document.querySelectorAll('[data-welcome-popup]').forEach((dialog) => {
      const closeButton = dialog.querySelector('[data-welcome-popup-close]');
      const delay = Number(dialog.dataset.delay || 0) * 1000;
      const hideDays = Number(dialog.dataset.hideDays || 0);
      const hasFormStatus = Boolean(dialog.querySelector('.welcome-popup__status'));
      let dismissedAt = 0;

      try {
        dismissedAt = Number(localStorage.getItem(storageKey) || 0);
      } catch {
        dismissedAt = 0;
      }

      const hideWindow = hideDays * 24 * 60 * 60 * 1000;
      const shouldShow = hasFormStatus || !dismissedAt || Date.now() - dismissedAt > hideWindow;

      const dismiss = () => {
        try {
          localStorage.setItem(storageKey, String(Date.now()));
        } catch {
          return dialog.close();
        }

        dialog.close();
      };

      closeButton?.addEventListener('click', dismiss);
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        dismiss();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dismiss();
      });

      if (window.Shopify?.designMode || shouldShow) {
        window.setTimeout(() => dialog.showModal(), hasFormStatus ? 0 : delay);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
